import { State } from '../../types'

export const getLoginField = (state: State) => state.LoginForm.field
export const getLoginFieldError = (state: State) => state.LoginForm.error
